import httpClient from '../httpService';
import { BSKT_LoaiNganh } from './LoaiNganhModels';

const LoaiNganhApiUrl = '/api/loainganh/';

export const loaiNganhService = {
    getAll: async (): Promise<BSKT_LoaiNganh[]> => {
        const res = await httpClient.get(`${LoaiNganhApiUrl}SelectAll`);
        return res?.data ?? [];
    },

    getById: async (id: number): Promise<BSKT_LoaiNganh> => {
        const res = await httpClient.get(`${LoaiNganhApiUrl}GetById/${id}`);
        return res.data.data;
    },

    create: async (body: BSKT_LoaiNganh): Promise<BSKT_LoaiNganh> => {
        const res = await httpClient.post(`${LoaiNganhApiUrl}Insert`, body);
        return res.data.data;
    },

    update: async (id: number, body: BSKT_LoaiNganh): Promise<any> => {
        const res = await httpClient.put(`${LoaiNganhApiUrl}Update/${id}`, body);
        return res.data.data;
    },

    delete: async (id: number): Promise<boolean> => {
        const res = await httpClient.delete(`${LoaiNganhApiUrl}Delete/${id}`);
        return res.data.data;
    }
};
